import React from "react";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const ReferenceDataComponent = () => {
  return (
    <main className="middle_section dashboard_middle mt-5">
      <div className="container">
        <NotSubscribedMessageComponent />
      </div>
    </main>
  );
};

export default ReferenceDataComponent;
